import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../components/AppShell";
import { Loader2 } from "lucide-react";
import { vendorGoogleAuth, formatErr } from "../lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function VendorAuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    if (!session_id) {
      toast.error("Sesión Google no recibida");
      navigate("/vendedores/login");
      return;
    }
    (async () => {
      try {
        const res = await vendorGoogleAuth(session_id);
        localStorage.setItem("el_vendor_token", res.access_token);
        // Clear the hash and go to dashboard
        window.history.replaceState(null, "", "/vendedores/panel");
        toast.success("Bienvenido");
        navigate("/vendedores/panel", { replace: true });
      } catch (err) {
        toast.error(formatErr(err));
        navigate("/vendedores/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="wizard-shell">
      <div className="wizard-frame fade-in">
        <header className="px-5 py-4 border-b border-slate-100">
          <Logo size={32} withWordmark />
        </header>
        <main className="flex-1 flex flex-col items-center justify-center text-center px-6 py-10">
          <Loader2 className="w-12 h-12 text-[var(--el-red)] animate-spin" />
          <h1 className="mt-5 text-xl font-[Outfit] font-bold text-slate-900">
            Conectando con Google...
          </h1>
          <p className="text-sm text-slate-500 mt-1">Un momento, te llevamos a tu panel.</p>
        </main>
      </div>
    </div>
  );
}
